// API Configuration for both development and production
const getApiBaseUrl = () => {
  // In production, use relative URLs (same domain)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  
  // In development, check if we're running the full stack locally
  // If backend is on 8081 and frontend on 3000, use direct connection
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default development setup - try proxy first, fallback to direct connection
  return window.location.hostname === 'localhost' ? 'http://localhost:8081' : '';
};

export const API_BASE_URL = getApiBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  CHATBOT_MESSAGE: `${API_BASE_URL}/api/chatbot/message`,
  CHATBOT_CONVERSATION: `${API_BASE_URL}/api/chatbot/conversation`,
  CHATBOT_FEEDBACK: `${API_BASE_URL}/api/chatbot/feedback`,
  CHATBOT_ESCALATE: `${API_BASE_URL}/api/chatbot/escalate`
};

console.log('API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: API_BASE_URL,
  ENDPOINTS: API_ENDPOINTS
}); 